import type { SelectorDefinition } from '@exodus/redux-dependency-injection';

import type { Assets } from '@/types';

const resultFunction = (allAvailableAssets: Assets): Assets =>
  Object.fromEntries(
    Object.entries(allAvailableAssets).filter(([, asset]) => !!asset.assetId),
  );

const allDefinition = {
  id: 'all',
  resultFunction,
  dependencies: [
    //
    { module: 'availableAssets', selector: 'all' },
  ],
} as const satisfies SelectorDefinition;

export default allDefinition;
